
import { Component, Vue } from "vue-property-decorator";
import Sidebar from "./Sidebar.vue";
import LayoutContent from "./LayoutContent.vue";

@Component({
  name: "default-layout",
  components: {
    Sidebar,
    LayoutContent,
  },
})
export default class DefaultLayout extends Vue {
  constructor() {
    super();
  }
}
